(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cika-product-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeStory(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('dialog');
    const trigger = root.querySelector('[data-cika-drawing-open]');
    if (dialog && trigger && typeof dialog.showModal === 'function') {
      let previousOverflow = '';
      trigger.addEventListener('click', event => {
        event.preventDefault();
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        trigger.focus({preventScroll: true});
      });
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        if (dialog.open) document.documentElement.style.overflow = previousOverflow;
      });
    }
    const items = [...root.querySelectorAll('.cika-story__faq details')];
    const states = new WeakMap();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function setExpanded(item, expanded) {
      const old = states.get(item);
      const start = item.getBoundingClientRect().height;
      const answer = item.querySelector('p');
      const startOpacity = item.open ? getComputedStyle(answer).opacity : '0';
      if (old) { old.height.cancel(); old.fade.cancel(); }
      item.open = true;
      const summary = item.querySelector('summary');
      const style = getComputedStyle(item);
      const end = expanded ? item.getBoundingClientRect().height : summary.getBoundingClientRect().height + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      item.dataset.expanded = String(expanded);
      summary.setAttribute('aria-expanded', String(expanded));
      if (reduced.matches || !item.animate) { item.open = expanded; states.delete(item); return; }
      const height = item.animate([{height: start + 'px'}, {height: end + 'px'}], {duration: 280, easing: 'cubic-bezier(.22,1,.36,1)'});
      const fade = answer.animate([{opacity: startOpacity}, {opacity: expanded ? 1 : 0}], {duration: 220, easing: 'ease-out'});
      const state = {height, fade};
      states.set(item, state);
      height.onfinish = () => { if (states.get(item) !== state) return; item.open = expanded; states.delete(item); };
    }
    items.forEach(item => {
      item.dataset.expanded = String(item.open);
      const summary = item.querySelector('summary');
      summary.setAttribute('aria-expanded', String(item.open));
      summary.addEventListener('click', event => {
        event.preventDefault();
        const expanding = item.dataset.expanded !== 'true';
        if (expanding) items.forEach(other => { if (other !== item && other.dataset.expanded === 'true') setExpanded(other, false); });
        setExpanded(item, expanding);
      });
    });
  }
  function initializeStories(scope) { scope.querySelectorAll('[data-cika-story]').forEach(initializeStory); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeStories(document), {once: true});
  else initializeStories(document);
  document.addEventListener('shopify:section:load', event => initializeStories(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
